<template>
  <div>
    <div class="text-muted small">{{notification.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->
    <!--<UserLink :user="notification.data.user"/>-->

    <!--CREATED-->
    <div>
      {{ $t('notifications.task.comment') }}

      <span> {{ $t('system.in') }}</span>

      <span> {{ $t('tasks.log.title') }}</span>
      "{{notification.data.task.title}}"
      <br />
      "{{notification.data.taskComment.comment}}"
      <br />
      <router-link
          :to="{ name: 'Home', params: { client: notification.data.task.project.client } }"
          v-if="getClient.projectModule"
      >
        {{$t('system.view')}} {{$t('tasks.open_tasks')}}
      </router-link>

    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'CollectionTaskComment',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    components: {
      UserLink,
      Avatar
    },
    props: {
      notification: {},
      changes: false
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }
        }
        return words.join(' ');
      }
    },
    created() {

    }
  }
</script>

<style scoped lang="scss">

</style>
